import React from 'react';

import { useFetchResults } from '../../../../controllers/results';
import { useFeatures } from '../../../../controllers/store';

const FetchResults = () => {
	useFetchResults();
	return null;
};

export const RegisterHooksWithNewFilters = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => {
	const [features] = useFeatures();
	return (
		<React.Fragment>
			{Boolean(features?.fetchInitialResults?.enabled) && <FetchResults />}
			{children}
		</React.Fragment>
	);
};
